import React from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/core/styles';
import {
  BUTTON_COMPONENT_PROPTYPES,
  CHILDREN_PROPTYPES
} from 'base/constants/propTypes';

const useDefaultStyles = makeStyles(theme => ({
  root: {
    color: theme.palette.secondary.main,
    padding: 0,
    textAlign: 'left',
    lineHeight: 1.2,
    '&:hover': {
      backgroundColor: 'transparent',
      opacity: '0.7'
    }
  }
}));

const SecondaryCta = ({
  handleClick,
  label,
  classes,
  component,
  href,
  fullWidth,
  to,
  dataTestId
}) => {
  const linkProps = {
    target: '_blank',
    rel: 'noopener noreferrer'
  };

  const styles = classes || useDefaultStyles();
  return (
    <Button
      fullWidth={fullWidth}
      component={component}
      onClick={handleClick}
      classes={styles}
      variant="text"
      href={href}
      to={to}
      {...(href ? linkProps : {})}
      data-testid={dataTestId}
    >
      {label}
    </Button>
  );
};

SecondaryCta.defaultProps = {
  fullWidth: false
};
SecondaryCta.propTypes = {
  fullWidth: PropTypes.bool,
  handleClick: PropTypes.func,
  label: CHILDREN_PROPTYPES,
  classes: PropTypes.shape({}),
  href: PropTypes.string,
  component: BUTTON_COMPONENT_PROPTYPES,
  to: PropTypes.oneOfType([PropTypes.string, PropTypes.shape({})]),
  dataTestId: PropTypes.string
};

export default SecondaryCta;
